import Script from 'next/script';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';

export type SIProps = {
  fields?: {
    /**
     * Comma-delimited list of google tag identifiers.
     */
    si?: string;
  };
};
const SiteImprove = ({ fields }: SIProps): JSX.Element => {
  // If we are running in experience editor we want to do nothing
  const isExperienceEditor = useExperienceEditor();
  if (isExperienceEditor) {
    return <></>;
  }
  // Read configured container tags from page fields
  const tag = (fields?.si ?? '').trim();

  // Allow for multiple comma-delimited tags
  const tags = tag
    .split(',')
    .map((x) => (x || '').trim())
    .filter((x) => x.length > 0);

  // If no tags configured then nothing to do
  if (tags.length === 0) {
    return <></>;
  }
  // Otherwise add the javascript and frames versions of the container to the page
  return (
    <>
      {tags.map((siTag) => {
        const scriptId = `nmdp-analytics-siteimprove-${siTag}`;
        return (
          <Script id={scriptId} key={scriptId} strategy="afterInteractive">
            {`(function() { var sz = document.createElement('script'); sz.type = 'text/javascript'; sz.async = true; ` +
              `sz.src = '//siteimproveanalytics.com/js/siteanalyze_${siTag}.js'; var s = document.getElementsByTagName('script')[0];` +
              `s.parentNode.insertBefore(sz, s); })();`}
          </Script>
        );
      })}
    </>
  );
};

export default SiteImprove;
